import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { validateEmail } from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemService from "../../../../services/supplier_appCommonService";
import toast from "react-hot-toast";
import { getPurchaseOrder } from "../../../../redux/feature/supplier_app/purchasingSlice";
import { useDispatch } from "react-redux";

const PoExtractModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    purchasingDocumentNr: "",
  });

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  // eslint-disable-next-line no-unused-vars
  const [getErrorFields, setErrorFields] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [disable, setDisabled] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    setDisabled(true);
    try {
      await ItemService.POExtraction(formData).then((item) => {
        if (item?.status === 200) {
          // console.log("item", item);
          toast.success(item?.message, {
            duration: 2000,
            position: "top-right",
          });
          setTimeout(() => {
            const materialPO = { queryName: "getSAPPO", module: "PO" };
            dispatch(getPurchaseOrder(materialPO));
          }, 1000);
        } else {
          console.error("Failed to send invitation:");
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setDisabled(false);
    }
    props?.onHide();
  };
  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  useEffect(() => {
    // Reset form when modal is closed
    if (!props.show) {
      setFormData({
        purchasingDocumentNr: "",
      });
    }
  }, [props.show, setFormData]);

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="lg"
      ref={ref}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>PO Extract</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col>
            <InputField
              className="inputBox"
              label="PO Document Nr"
              name="purchasingDocumentNr"
              id="purchasingDocumentNr"
              extraLabel=""
              value={formData.purchasingDocumentNr || ""}
              onChange={handleChange}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={handleSubmit}
          disabled={disable}
          className="btn btn-primary"
        >
          PO Extract
        </button>
        <button onClick={props?.onHide} className="btn btn-danger">
          Cancel
        </button>
      </Modal.Footer>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </Modal>
  );
});

export default PoExtractModal;
